function ErrorMessageComponent({ message }) {
  const value = message ? <p className="error">{message}</p> : null;
  return value;
}

export default ErrorMessageComponent;
